import Home from "./Pages/Home";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

import AboutUs from "./Pages/AboutUs";
import Policy from "./Pages/Policy";
import Terms from "./Pages/Terms";
import Contact from "./Pages/Contact";
import mixpanel from "mixpanel-browser";
import { useEffect } from "react";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/contact-us",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Policy />,
  },

  {
    path: "/about",
    element: <AboutUs />,
  },

  {
    path: "*",
    element: <Navigate to={"/"} />,
  },
]);

const PROJECT_TOKEN = "20bc20e92982f5e45dccfa3e164e4739";
mixpanel.init(PROJECT_TOKEN, {
  debug: true,
  ignore_dnt: true,
  track_pageview: "full-url",
});

function App() {
  useEffect(() => {
    mixpanel.track("Website-URL-Launched");
  }, []);

  return (
    <div className="">
      <HelmetProvider>
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          closeOnClick
          ltr={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
          hideProgressBar={true}
        />
      </HelmetProvider>
    </div>
  );
}

export default App;
